import { __decorate } from "tslib";
import { attr } from '@microsoft/fast-element';
import { AccordionItem } from '@microsoft/fast-foundation';
import { ChameleonElementMixin } from '../common/ChameleonElement';
export class AccordionItemComponent extends ChameleonElementMixin(AccordionItem) {
    constructor() {
        super(...arguments);
        this.fullwidth = false;
        this.chevronPosition = 'right';
    }
    connectedCallback() {
        super.connectedCallback();
        this.classList.toggle('has-stepper-badge', !!this.querySelector('[slot="start"]'));
    }
}
__decorate([
    attr({ mode: 'boolean' })
], AccordionItemComponent.prototype, "fullwidth", void 0);
__decorate([
    attr({ attribute: 'chevron-position' })
], AccordionItemComponent.prototype, "chevronPosition", void 0);
